(async function () {
  var config = document.getElementById('GeoSaleRouting');

  if (!config || (window.Shopify && window.Shopify.designMode)) return;

  var eastCountryCodes = ['AU', 'SG', 'JP', 'MY', 'AE', 'SA'];
  var fallbackCountryCode = (config.dataset.countryCode || '').toUpperCase();
  var currentHandle = config.dataset.currentHandle;
  var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : config.dataset.rootUrl || '/';
  rootUrl = rootUrl.replace(/\/*$/, '/');
  var eastHandle = 'bestsellers-on-sale';
  var westHandle = 'sale';

  function applyRouting(countryCode) {
    var expectedHandle = eastCountryCodes.indexOf(countryCode) !== -1 ? eastHandle : westHandle;
    var destination = rootUrl + 'collections/' + expectedHandle;

    document.querySelectorAll('[data-geo-sale-link]').forEach(function (link) {
      link.href = destination;
    });

    if ((currentHandle === eastHandle || currentHandle === westHandle) && currentHandle !== expectedHandle) {
      window.location.replace(destination + window.location.search + window.location.hash);
    }
  }

  try {
    var response = await fetch(rootUrl + 'browsing_context_suggestions.json?country[enabled]=true', {
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Country detection request failed');

    var data = await response.json();
    var detectedCountryCode = data.detected_values.country.handle.toUpperCase();
    applyRouting(detectedCountryCode);
  } catch (error) {
    applyRouting(fallbackCountryCode);
  }
})();
